export default __webpack_public_path__ + "static/media/thangloi.32bc906f.jpeg";